export default function getInstallationDetails() {
  return window?.$dt?.objMyInstallInfo || {};
}
